export const START_LOADING = 'START_LOADING'

export const GET_PROJECT_DESCRIPTION_SUCCESS = 'GET_PROJECT_DESCRIPTION_SUCCESS';
export const POST_PROJECT_DESCRIPTION_SUCCESS = 'POST_PROJECT_DESCRIPTION_SUCCESS';
export const GET_PROJECT_DESCRIPTION_FAIL = 'GET_PROJECT_DESCRIPTION_FAIL';
export const POST_PROJECT_DESCRIPTION_FAIL = 'POST_PROJECT_DESCRIPTION_FAIL';

export const GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS = 'GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS';
export const POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS = 'POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_SUCCESS';
export const GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL = 'GET_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL';
export const POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL = 'POST_BUSINESS_AS_USUAL_FOR_FEEDSTOCK_FAIL';

export const GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS = 'GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS';
export const POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS = 'POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_SUCCESS';
export const GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL = 'GET_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL';
export const POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL = 'POST_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT_FAIL';

export const GET_FEEDSTOCK_SOURCE_SUCCESS = 'GET_FEEDSTOCK_SOURCE_SUCCESS';
export const POST_FEEDSTOCK_SOURCE_SUCCESS = 'POST_FEEDSTOCK_SOURCE_SUCCESS';
export const GET_FEEDSTOCK_SOURCE_FAIL = 'GET_FEEDSTOCK_SOURCE_FAIL';
export const POST_FEEDSTOCK_SOURCE_FAIL = 'POST_FEEDSTOCK_SOURCE_FAIL';

export const GET_BURN_SUPERVISOR_SUCCESS = 'GET_BURN_SUPERVISOR_SUCCESS';
export const POST_BURN_SUPERVISOR_SUCCESS = 'POST_BURN_SUPERVISOR_SUCCESS';
export const GET_BURN_SUPERVISOR_FAIL = 'GET_BURN_SUPERVISOR_FAIL';
export const POST_BURN_SUPERVISOR_FAIL = 'POST_BURN_SUPERVISOR_FAIL';

export const GET_PROJECT_STAKEHOLDERS_SUCCESS = 'GET_PROJECT_STAKEHOLDERS_SUCCESS';
export const POST_PROJECT_STAKEHOLDERS_SUCCESS = 'POST_PROJECT_STAKEHOLDERS_SUCCESS';
export const GET_PROJECT_STAKEHOLDERS_FAIL = 'GET_PROJECT_STAKEHOLDERS_FAIL';
export const POST_PROJECT_STAKEHOLDERS_FAIL = 'POST_PROJECT_STAKEHOLDERS_FAIL';

export const GET_ENTITY_DETAILS_SUCCESS = 'GET_ENTITY_DETAILS_SUCCESS';
export const POST_ENTITY_DETAILS_SUCCESS = 'POST_ENTITY_DETAILS_SUCCESS';
export const GET_ENTITY_DETAILS_FAIL = 'GET_ENTITY_DETAILS_FAIL';
export const POST_ENTITY_DETAILS_FAIL = 'POST_ENTITY_DETAILS_FAIL';

